module.exports = __webpack_public_path__ + "static/media/alert-triangle-icon.4cd956d2.svg";